/**
 * Closed dates configuration (UK time).
 * Add dates in "YYYY-MM-DD" format.
 * The helper checks if the current date in Europe/London falls on one of these.
 */
const CLOSED_DATES = ["2026-07-15", "2026-07-27"];

const CLOSED_REASON = "staff training";

/**
 * Current date in the UK as "YYYY-MM-DD".
 */
function ukToday() {
  return new Date().toLocaleDateString("en-CA", {
    timeZone: "Europe/London",
  });
}

/**
 * Returns true if the current UK date matches any closed date.
 */
export function isRestaurantClosed() {
  return CLOSED_DATES.includes(ukToday());
}

/**
 * Formats "2026-08-03" as "Monday 3rd August".
 */
function formatClosedDate(isoDate) {
  const [year, month, day] = isoDate.split("-").map(Number);
  const date = new Date(year, month - 1, day);

  const weekday = date.toLocaleDateString("en-GB", { weekday: "long" });
  const monthName = date.toLocaleDateString("en-GB", { month: "long" });

  return `${weekday} ${day}${ordinalSuffix(day)} ${monthName}`;
}

function ordinalSuffix(day) {
  if (day > 3 && day < 21) return "th";
  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
}

/**
 * The days to mention in the closed notice: "today" plus any future closed
 * dates, so the wording never contradicts the current date.
 */
export function getClosedDays() {
  const today = ukToday();
  const upcoming = CLOSED_DATES.filter((d) => d > today).sort();

  return [
    ...(CLOSED_DATES.includes(today) ? ["today"] : []),
    ...upcoming.map(formatClosedDate),
  ];
}

export { CLOSED_DATES, CLOSED_REASON };
